import { DropdownItem } from "@app/shared/checkbox-dropdown/types";
import { FC, useRef } from "react";
import { TimeFrameOptions } from "../interfaces";
import { NewActionMenu, NewActionMenuItem } from "@app/shared/action-menu";

interface EnterpriseComplianceDashboardTimeframeProps {
    disabled?: boolean;
    tileKey: string;
    onChange: (value: string) => void;
    selectedKey: TimeFrameOptions;
}

const EnterpriseComplianceDashboardTimeFrame: FC<EnterpriseComplianceDashboardTimeframeProps> = (props: EnterpriseComplianceDashboardTimeframeProps) => {
    const options = useRef<DropdownItem<TimeFrameOptions>[]>(
        [
            {
                key: TimeFrameOptions.Three,
                name: TimeFrameOptions.Three,
            },
            {
                key: TimeFrameOptions.Six,
                name: TimeFrameOptions.Six,
            },
            {
                key: TimeFrameOptions.Twelve,
                name: TimeFrameOptions.Twelve,
            },
            {
                key: TimeFrameOptions.Fifteen,
                name: TimeFrameOptions.Fifteen,
            },
        ]
    ).current;

    return (
        <NewActionMenu
            buttonText={`Time Frame: ${props.selectedKey}`}
            loading={props.disabled}
            buttonClassNames="qes-button-secondary py-0"
            testId={`ecd-time-frame__dropdown--${props.tileKey}`}
            key={props.selectedKey}
        >
            {options.map((option) => {
                const isSelected = option.key === props.selectedKey;
                return (
                    <NewActionMenuItem
                        display={option.name}
                        isSelected={isSelected}
                        key={option.key}
                        onClick={() => props.onChange(option.key)}
                        testId={`ecd-time-frame__option--${option.key}`}
                    />
                );
            })}
        </NewActionMenu>
    )
}

export default EnterpriseComplianceDashboardTimeFrame;
